import React from "react";
import { Link } from "react-router-dom";
import SiteFooter from "../../general/components/layout/SiteFooter";
import SiteNavbar from "../../general/components/layout/SiteNavbar";
import { serviceDetails } from "../assets/serviciosDetalle";
import ServiceCta from "../components/ServiceCta";
import ServiceGlyph from "../components/ServiceGlyph";
import ServiceSectionHead from "../components/ServiceSectionHead";
import serviciosNavTheme from "../components/serviciosNavTheme";

const service = serviceDetails["politicas-publicas-inteligencia-institucional"];
const policyNavTheme = {
    ...serviciosNavTheme,
    primary: "#466b92",
    primaryDark: "#2f4e6d",
    primaryLight: "#aec2d5",
    pale: "rgba(70, 107, 146, 0.09)",
};

function PolicyHero() {
    return (
        <section className="service-detail-hero policy-service-hero">
            <div className="service-detail-inner">
                <div className="service-detail-bread">
                    <Link to="/">Inicio</Link>
                    <span>/</span>
                    <Link to="/servicios">Servicios Empresariales</Link>
                    <span>/</span>
                    <strong>Políticas Públicas</strong>
                </div>
                <span className="service-hero-tag">Servicio empresarial</span>
                <h1>{service.title}</h1>
                <p>{service.subtitle}</p>
            </div>
        </section>
    );
}

function ContextSection() {
    const { context } = service;

    return (
        <section className="service-detail-section policy-context-section">
            <div className="service-detail-inner">
                <ServiceSectionHead section={context} />
                <div className="service-split">
                    <div className="service-copy-block">
                        {context.paragraphs.map((paragraph) => (
                            <p key={paragraph}>{paragraph}</p>
                        ))}
                    </div>
                    <aside className="policy-context-aside">
                        <h3>Servicios</h3>
                        {context.services.map((item) => (
                            <div className="policy-context-item" key={item.number}>
                                <span>{item.number}</span>
                                <div>
                                    <h4>{item.title}</h4>
                                    <p>{item.text}</p>
                                </div>
                            </div>
                        ))}
                    </aside>
                </div>
            </div>
        </section>
    );
}

function AudienceSection() {
    const { audience } = service;

    return (
        <section className="service-detail-section is-soft policy-audience-section">
            <div className="service-detail-inner">
                <ServiceSectionHead section={audience} />
                <div className="policy-audience-grid">
                    {audience.items.map((item) => (
                        <article className="policy-audience-card" key={item.text}>
                            <span className="policy-audience-icon">
                                <ServiceGlyph type={item.icon} />
                            </span>
                            <p>{item.text}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}

function ServiceLineSection({ line, index }) {
    const layoutClass = index === 1 ? "is-card-layout" : "is-compact-detail-layout";

    return (
        <section className={`service-detail-section policy-line-section ${layoutClass} ${index % 2 === 1 ? "is-soft" : ""}`}>
            <div className="service-detail-inner">
                <div className="policy-line-heading">
                    <span className="policy-line-number">{line.number}</span>
                    <div>
                        <span className="policy-line-kicker">{line.kicker}</span>
                        <h2>{line.title}</h2>
                    </div>
                </div>

                <p className="policy-line-description">{line.description}</p>
                <div className="policy-line-details">
                    {line.details.map((item) => (
                        <article key={item.title}>
                            <h3>{item.title}</h3>
                            <p>{item.text}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}

function ValueSection() {
    const { value } = service;

    return (
        <section className="service-detail-section is-soft policy-value-section">
            <div className="service-detail-inner">
                <ServiceSectionHead section={value} />
                <div className="policy-value-grid">
                    {value.items.map((item) => (
                        <article key={item.number}>
                            <h3>{item.title}</h3>
                            <p>{item.text}</p>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default function PoliticasPublicasEInteligenciaInstitucional() {
    return (
        <div className="servicios servicio-detalle service-page-politicas-publicas">
            <SiteNavbar
                activeSection="servicios"
                ctaLabel="Contactar"
                ctaHref="#contacto"
                navTheme={policyNavTheme}
            />
            <PolicyHero />
            <ContextSection />
            <AudienceSection />
            {service.serviceLines.map((line, index) => (
                <ServiceLineSection key={line.number} line={line} index={index} />
            ))}
            <ValueSection />
            <ServiceCta service={service} id="contacto" />
            <SiteFooter />
        </div>
    );
}
